import React from 'react';
import { ControlsSection } from '@/components/ControlsSection';

export function ControlsSectionWrapper(props) {
  return <ControlsSection {...props} />;
}